import React from 'react'
import "../../style.css";

import logo from "../../images/logo.png"

const Banner = () => {
    return (
        <div className='container banner-container'>
            <div className='row m-0'>
                <div className='col-12 p-0 text-center'>
                    <img className='logo img-fluid' src={logo}></img>
                </div>
            </div>
        </div>
    )
}

export default Banner